var Backbone = require('backbone'),
    fvChannel = require('glRadio').channel('FV'),
    $ = require('jquery'),
    AuthState = require('./authState');

/*
* This model hold attributes from either an auth or keep alive request 'FeithSessionWeb' object.
* */

module.exports = Backbone.Model.extend({

    initialize: function() {

        this.state = new AuthState();

    },
    url: function() {
        return fvChannel.request('apiUrl').login;
    },

    /**
     * Override for specific $ ajax overrides sent to options in Backbone.sync ( DVBC-1775 ).
     * data: from data from login form -- object of key value pairs.
     * jqAjax, if provided json object of key value pairs will convert it to form data when processData is true.
     */
    fetch: function( options ) {

        var bb_sync_ajax_options = {
            data: options.data,
            context: options.context,
            type: 'POST',
            contentType: 'application/x-www-form-urlencoded'
        };

        return Backbone.Model.prototype.fetch.call( this, bb_sync_ajax_options );

    },

    /* API entry point that logs in or out */
    setUserAuth: function(isAuth, options) {
        var state = this.state;
        if (isAuth) {
            state.login(); //attributes set on fetch
        } else {
            this.clear(); //clear previous session login data
            this.state.logout(options);
        }
    },
    /*
    *  Call keepAlive and set the attributes of this model to the response.
    *  Essentially the equivalent of a fetch of this model, as login returns the same 'FeithSessionWeb' object.
    *  Now only called by FV.addViewer in it's sequence of operations ...
    *  If first authentication wasn't done, logs in via keep alive -- storing the auth attr's on this model.
    *  If the auth data model is empty but the user wasn't timed out -- restore the data.
    *  FV.addViewer occurs on load of FV library which can include a page refresh -- if our session hasn't timed-out,
    *  this will populate the model and return sucessfully.
    *  MUST be done prior to rendering so permissions in templates exist.
    * */
    loginViaKeepAlive: function(cxt) {

        cxt = cxt || this;

        var self = this;

        return $.Deferred( function($dfd) {

            self._keepAlive().done( function( authAttrs ) {
                self.set( authAttrs, {set: false} );  //store the attributes on the auth model
                $dfd.resolveWith(cxt);

            }).fail( function() {
                $dfd.rejectWith(cxt, [arguments]);
            });

        }).promise(); 
        
    },
    // Now always returns data : returns either login with session data or 401
    _keepAlive: function() { 
        return $.ajax({
            url: fvChannel.request('apiUrl').keepAlive,
            type: 'GET'
        });
    },
     /* Note :not yet used in interface */
    logOut: function() {

        if ( !this.state.firstAuthCompleted() )
            return;

        $.ajax({
             url: fvChannel.request('apiUrl').logout,
             method: 'GET'
        }).done( function() {

            fvChannel.command('userLoggedOut', {fromLogOut: true});

        }).fail( function(jqXHR){

            fvChannel.command('userLogoutError', jqXHR);
        });

    },
    loggedOutFromSessionTimeout: function() {
        return this.state.didSessionTimeout();
    },
    getLogInError: function() {
        return this.state.loginErr();
    },
    didFirstAuthenticationOccur: function() {
        return this.state.firstAuthCompleted();
    },
    isAuthenticated: function() {
        return this.state.isAuthenticated();
    },
    /*
     * eg: "fdd92_pecan"
     */
    getDataService: function() {
        return this.get('dataService');
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/FV/authentication/authentication.js
 ** module id = 759
 ** module chunks = 0
 **/